import type * as React from 'react';

interface PartnerSVGProps {
  className?: string;
}

const PartnerSVG: React.FC<PartnerSVGProps> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <title>Partner SVG</title>
    <path
      d="M3 21H21M6 18V10M10 18V10M14 18V10M18 18V10M20 7L12.424 2.265C12.2702 2.16886 12.1933 2.12079 12.1108 2.10205C12.0379 2.08548 11.9621 2.08548 11.8892 2.10205C11.8067 2.12079 11.7298 2.16886 11.576 2.265L4 7H20Z"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default PartnerSVG;
